import ForgotPasswordForm from './ForgotPasswordForm';
import ForgotPassword from './ForgotPassword';

export { ForgotPasswordForm, ForgotPassword };
